import { render, staticRenderFns } from "./card-address.vue?vue&type=template&id=0bf91406&scoped=true"
import script from "./card-address.vue?vue&type=script&lang=js"
export * from "./card-address.vue?vue&type=script&lang=js"
import style0 from "./card-address.vue?vue&type=style&index=0&id=0bf91406&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf91406",
  null
  
)

export default component.exports